export const jmrSquaredAttribution = {
  studioName: 'JMR Squared',
  studioUrl: 'https://tech.jmrsquared.com/',
  contactEmail: 'tech@jmrsquared.com',
  contactMailto: 'mailto:tech@jmrsquared.com',
  creditLabel: 'Unsolicited demo preview by',
  similarSiteMessage: 'Want a similar website? Email',
} as const;
